#import '../../../../../core-entity/graphql/fragments/core-entity-task-fragment.graphql'

query GetTasksForPeep($peepId: ID!) {
    peep(id: $peepId) {
        id
        name
        tasks {
            ...CoreEntityTaskFragment
        }
    }
}
